import { addHours, eachWeekOfInterval, startOfWeek } from "date-fns";

import { DayOfWeek } from "./DayOfWeek";
import { FullWeek } from "./FullWeek";
import { middleOfDay } from "./middleOfDay";

interface DateToRangeFullWeeksOptions {
  weekStartsOn: DayOfWeek;
  locale?: Locale;
}

const defaultOptions: DateToRangeFullWeeksOptions = {
  weekStartsOn: DayOfWeek.MONDAY,
};

export const dateRangeToFullWeeks = (
  startDate: Date,
  endDate: Date,
  opts: Partial<DateToRangeFullWeeksOptions> = {},
): FullWeek[] => {
  const options = { ...defaultOptions, ...opts };
  const beginningOfFirstWeek = startOfWeek(startDate, options);

  return eachWeekOfInterval(
    {
      start: beginningOfFirstWeek,
      end: endDate,
    },
    options,
  )
    .map(middleOfDay)
    .map(firstDayOfWeek => [
      firstDayOfWeek,
      addHours(firstDayOfWeek, 24),
      addHours(firstDayOfWeek, 2 * 24),
      addHours(firstDayOfWeek, 3 * 24),
      addHours(firstDayOfWeek, 4 * 24),
      addHours(firstDayOfWeek, 5 * 24),
      addHours(firstDayOfWeek, 6 * 24),
    ]);
};
